import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import TrunksIp from './components/TrunksIp';
import TrunksAuth from './components/TrunksAuth';

import { accessLocalStorage, exportUpdateTrunks, exportSelectTrunkById, valuesAnalyze, changeViewForms, readAllTenant, sendReloadAsteriskSystem, checkTrunkUsage } from '../../../services';

import Loading from '../../Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './TrunksForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPhoneSquareAlt, faPhone, faSave, faArrowLeft, faEdit } from '@fortawesome/free-solid-svg-icons';

function TrunksEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({
    "ipLocal": "",
    "trunkNumber": "",
    "authUsername": "",
    "password": "",
    "tenant": "",
    "realNumber": "",
    "provider": "",
    "ipSbcTrunk": "",
    "codec": [],
    "type": "",
    "mode": "bidirecional"
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [canEditName, setCanEditName] = useState(true);
  const [trunkUsageInfo, setTrunkUsageInfo] = useState(null);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!idtenant.includes('vgs')) fetchTenants = fetchTenants.filter((tenant) => tenant.short_name === idtenant);
    setTenants(fetchTenants);
  }, [history]);

  const validateField = (name, value, currentValues = values) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'trunkNumber') {
      if (!value || value.trim() === '') return false;
      return checkNumber(value);
    }

    if(name === 'password') {
      if (!value || value.trim() === '') return false;
      return value.length > 5;
    }

    if(name === 'mode') {
      return value === 'bidirecional' || value === 'unidirecional';
    }

    if(name === 'realNumber') {
      // Só validar se o modo for unidirecional
      if (currentValues.mode === 'unidirecional') {
        if (!value || value.trim() === '') return false;
        return value.length >= 10;
      }
      return true; // Se não for unidirecional, não precisa validar
    }

    if(name === 'provider' || name === 'authUsername') {
      if (!value || value.trim() === '') return false;
      return isTripleChar(value);
    }

    if(name === 'ipSbcTrunk' || name === 'ipLocal') {
      if (!value || value.trim() === '') return false;
      return true; // Validação básica de IP pode ser adicionada depois
    }

    if(name === 'tenant') {
      return value && value.trim() !== '';
    }

    if(name === 'type') {
      return value === 'IP' || value === 'Auth';
    }

    if(name === 'codec') {
      return Array.isArray(value) ? value.length > 0 : (value && value.trim() !== '');
    }

    return true;
  };

  const validateAllFields = useCallback((vals) => {
    const newValidate = {};
    
    // Campos sempre obrigatórios
    newValidate.type = validateField('type', vals.type, vals);
    // Se o nome não pode ser editado, sempre considerar válido
    newValidate.provider = !canEditName ? true : validateField('provider', vals.provider, vals);
    newValidate.ipSbcTrunk = validateField('ipSbcTrunk', vals.ipSbcTrunk, vals);
    newValidate.tenant = validateField('tenant', vals.tenant, vals);
    newValidate.mode = validateField('mode', vals.mode, vals);
    newValidate.codec = validateField('codec', vals.codec, vals);
    
    // Campos condicionais baseado no tipo
    if (vals.type === 'IP') {
      newValidate.trunkNumber = validateField('trunkNumber', vals.trunkNumber, vals);
      newValidate.ipLocal = validateField('ipLocal', vals.ipLocal, vals);
      // Para IP, authUsername e password não são necessários
      newValidate.authUsername = true;
      newValidate.password = true;
    } else if (vals.type === 'Auth') {
      newValidate.authUsername = validateField('authUsername', vals.authUsername, vals);
      newValidate.password = validateField('password', vals.password, vals);
      // Para Auth, trunkNumber e ipLocal não são necessários
      newValidate.trunkNumber = true;
      newValidate.ipLocal = true;
    } else {
      // Se tipo ainda não foi definido, considerar todos como válidos temporariamente
      newValidate.trunkNumber = true;
      newValidate.ipLocal = true;
      newValidate.authUsername = true;
      newValidate.password = true;
    }
    
    // realNumber só é necessário se modo for unidirecional
    if (vals.mode === 'unidirecional') {
      newValidate.realNumber = validateField('realNumber', vals.realNumber, vals);
      } else {
      newValidate.realNumber = true;
    }
    
    return newValidate;
  }, [canEditName]);

  const loadTrunkData = useCallback(async () => {
    if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
      setLoading(false);
      history.push('/config/tronco/lista');
      return;
    }

    setLoading(true);
    try {
      const result = await exportSelectTrunkById({ elements: itemsSelectedToEdit[0] });
      
      if (result && result.length > 0) {
        const trunk = result[0];
        
        // Extrair dados do trunk para o formulário
        let serverIP = '';
        let localIP = '';
        
        if (trunk.serverIP) {
          // Formato pode ser: "sip:username@ip:port" ou "sip:ip:port" ou apenas "ip"
          if (trunk.serverIP.includes('sip:')) {
            const sipPart = trunk.serverIP.split('sip:')[1];
            if (sipPart.includes('@')) {
              // Formato: sip:username@ip:port
              serverIP = sipPart.split('@')[1].split(':')[0];
            } else {
              // Formato: sip:ip:port
              serverIP = sipPart.split(':')[0];
            }
          } else if (trunk.serverIP.includes(':')) {
            // Formato: ip:port
            serverIP = trunk.serverIP.split(':')[0];
          } else {
            // Formato: apenas ip
            serverIP = trunk.serverIP;
          }
        }
        
        if (trunk.localIP) {
          // Formato pode ser: "sip:username@ip:port" ou "sip:ip:port" ou apenas "ip"
          if (trunk.localIP.includes('sip:')) {
            const sipPart = trunk.localIP.split('sip:')[1];
            if (sipPart.includes('@')) {
              // Formato: sip:username@ip:port
              localIP = sipPart.split('@')[1].split(':')[0];
            } else {
              // Formato: sip:ip:port
              localIP = sipPart.split(':')[0];
            }
          } else if (trunk.localIP.includes(':')) {
            // Formato: ip:port
            localIP = trunk.localIP.split(':')[0];
          } else {
            // Formato: apenas ip
            localIP = trunk.localIP;
          }
        }
        
        const trunkType = trunk.nameuser ? 'Auth' : 'IP';
        
        // Converter codec de string para array se necessário
        let codecArray = [];
        if (trunk.codec) {
          if (typeof trunk.codec === 'string') {
            codecArray = trunk.codec.split(',').map(c => c.trim()).filter(c => c);
          } else if (Array.isArray(trunk.codec)) {
            codecArray = trunk.codec;
          }
        }
        
        const trunkValues = {
          provider: trunk.name || '',
          ipSbcTrunk: serverIP || '',
          ipLocal: localIP || '',
          trunkNumber: trunk.trunk || '',
          codec: codecArray,
          authUsername: trunk.nameuser || '',
          password: trunk.pass || '',
          type: trunkType,
          tenant: trunk.tenant || '',
          mode: trunk.mode || 'bidirecional',
          realNumber: trunk.real_number || ''
        };

        setValues(trunkValues);

        const usageCheck = await checkTrunkUsage(itemsSelectedToEdit[0]);
        if (usageCheck && usageCheck.hasConfigurations) {
          setCanEditName(false);
          setTrunkUsageInfo(usageCheck);
        } else {
          setCanEditName(true);
          setTrunkUsageInfo(null);
        }

        // Validar todos os campos após carregar os dados
        setTimeout(() => {
          const initialValidate = validateAllFields(trunkValues);
          setValidate(initialValidate);
        const hasInvalid = Object.values(initialValidate).some(v => v === false);
        setDisable(hasInvalid);
          
        // Mostrar/esconder formulários baseado no tipo
          if (trunkType === 'IP') {
            changeVisibityMessages(false, 'trunk-ip-div');
            changeVisibityMessages(true, 'trunk-auth-div');
          } else {
            changeVisibityMessages(false, 'trunk-auth-div');
            changeVisibityMessages(true, 'trunk-ip-div');
          }
          
          if (trunk.real_number) {
            const realNumberFieldIP = document.getElementById('realNumber-field');
            const realNumberFieldAuth = document.getElementById('realNumber-field-auth');
            if (realNumberFieldIP) realNumberFieldIP.style.display = 'flex';
            if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'flex';
          }
          
          // Mostrar botão de envio já que o tipo está definido
          changeVisibityMessages(false, 'button-send-form');
        }, 100);
      }
    } catch (error) {
      console.error('Erro ao carregar dados do trunk:', error);
      history.push('/config/tronco/lista');
    } finally {
      setLoading(false);
    }
  }, [itemsSelectedToEdit, history, validateAllFields]);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const isValid = validateField(name, value, values);
    // Não validar visualmente campos que não têm elementos de erro no DOM
    if (name !== 'mode' && name !== 'tenant') {
      changeScreen(isValid, name);
    }
    return isValid;
  };

  const handleChangeCodec = (name, value) => {
    let prevSetValueCodec = values[name];

    if (!values.hasOwnProperty('codec')) prevSetValueCodec = [];
    if (typeof prevSetValueCodec === 'string') prevSetValueCodec = prevSetValueCodec.split(',').map(c => c.trim()).filter(c => c);
    prevSetValueCodec = prevSetValueCodec.includes(value) ? prevSetValueCodec.filter((codec) => codec !== value) : [...prevSetValueCodec, value];
    prevSetValueCodec.toString();

    setValues((prevState) => prevState, values[name] = prevSetValueCodec);
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    
    if (name === 'codec') {
      handleChangeCodec(name, value);
      // Revalidar após mudança de codec
      setTimeout(() => {
        const updatedValues = { ...values, codec: values.codec };
        const newValidate = validateAllFields(updatedValues);
        setValidate(newValidate);
        const hasInvalid = Object.values(newValidate).some(v => v === false);
        setDisable(hasInvalid);
      }, 0);
    } else if (name === 'mode') {
      // Tratamento especial para mudança de modo
      const updatedValues = { 
        ...values, 
        [name]: value,
        realNumber: value === 'bidirecional' ? '' : values.realNumber
      };
      setValues(updatedValues);
      
      // Mostrar/esconder campo realNumber baseado no modo selecionado
      const realNumberFieldIP = document.getElementById('realNumber-field');
      const realNumberFieldAuth = document.getElementById('realNumber-field-auth');
      
      if (value === 'unidirecional') {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'flex';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'flex';
      } else {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'none';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'none';
      }
      
      // Revalidar todos os campos após mudança de modo
      setTimeout(() => {
        const fullValidate = validateAllFields(updatedValues);
        setValidate(fullValidate);
        const hasInvalid = Object.values(fullValidate).includes(false);
        setDisable(hasInvalid);
      }, 0);
    } else {
      const updatedValues = { ...values, [name]: value };
      setValues(updatedValues);
      
      // Revalidar todos os campos após a mudança
      setTimeout(() => {
        const fullValidate = validateAllFields(updatedValues);
        setValidate(fullValidate);
        const hasInvalid = Object.values(fullValidate).includes(false);
        setDisable(hasInvalid);
      }, 0);
    }
    return;
  };

  const typeTrunkSelected = (item) => {
    const { value } = item;
    if (value === 'IP') {
      changeVisibityMessages(false, 'trunk-ip-div');
      changeVisibityMessages(true, 'trunk-auth-div');
      changeVisibityMessages(false, 'button-send-form');
      handleChangeValues(item);
      return;
    }

    changeVisibityMessages(false, 'trunk-auth-div');
    changeVisibityMessages(true, 'trunk-ip-div');
    changeVisibityMessages(false, 'button-send-form');
    handleChangeValues(item);
    return;
  };

  const sendDataTrunkUpdate = async () => {
    const dataToSend = {
      trunkName: itemsSelectedToEdit[0],
      ...values,
      codec: Array.isArray(values.codec) ? values.codec.join(',') : values.codec
    };
    
    try {
      const fetchTrunks = await exportUpdateTrunks(dataToSend);
      
      if (fetchTrunks && fetchTrunks.success) {
        try {
          await sendReloadAsteriskSystem({ command: 'asterisk' });
        } catch (reloadError) {
          console.warn('Aviso: Erro ao recarregar Asterisk, mas a atualização foi bem-sucedida:', reloadError);
        }
        
        toggleIsChangeFormElements('trunk-all-form', 'is-hidden');
        changeVisibityMessages(false, 'success-update-trunks');
        
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        setTimeout(() => {
          history.push('/config/tronco/lista');
        }, 3000);
      } else {
        const errorMessage = fetchTrunks?.message || fetchTrunks?.error || 'Erro ao atualizar tronco';
        const errorCode = fetchTrunks?.code;
        
        if (errorCode === 'NAME_CHANGE_BLOCKED') {
          const usageInfo = fetchTrunks?.usage;
          const alertMessage = `Não é possível alterar o nome do tronco pois ele possui ${usageInfo?.totalCount || 0} configuração(ões) de chamadas ativa(s).`;
          
          const errorAlert = document.getElementById('nosuccess-update-trunks');
          if (errorAlert) {
            const alertBody = errorAlert.querySelector('.alert-body');
            if (alertBody) {
              alertBody.innerHTML = `<strong>${errorMessage}</strong><br />${alertMessage}`;
            }
          }
        }
        
        changeVisibityMessages(false, 'nosuccess-update-trunks');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (error) {
      console.error('Erro ao atualizar tronco:', error);
      changeVisibityMessages(false, 'nosuccess-update-trunks');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  useEffect(() => {
    // Aguardar tenants serem carregados antes de verificar seleção
    if (tenants.length === 0) return;
    
    // Se temos um tronco selecionado, carregar dados
    if (itemsSelectedToEdit && itemsSelectedToEdit.length > 0) {
      loadTrunkData();
    } else {
      // Se não há tronco selecionado após um delay, redirecionar
      const timeoutId = setTimeout(() => {
        if (!itemsSelectedToEdit || itemsSelectedToEdit.length === 0) {
          history.push('/config/tronco/lista');
        }
      }, 1000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [itemsSelectedToEdit, tenants, history, loadTrunkData]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="trunks-form-container">
      <div className="trunks-form-header">
        <div className="trunks-form-title-wrapper">
          <svg className="trunks-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
    <div>
            <h1 className="trunks-form-title">Editar Tronco</h1>
            <p className="trunks-form-subtitle">Atualize as configurações do tronco SIP</p>
          </div>
        </div>
        <Link to="/config/tronco/lista" className="btn-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar
        </Link>
      </div>

      <div className="alerts-section">
        <div id="nosuccess-update-trunks" name="nosuccess-update-trunks" className="alert-message alert-danger is-hidden">
          <div className="alert-header">
            <span>Erro!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#nosuccess-update-trunks')}>×</button>
        </div>
          <div className="alert-body">
            <strong>Não foi possível atualizar o tronco!</strong><br />
            Verifique os dados e tente novamente.
        </div>
        </div>

        <div id="success-update-trunks" name="success-update-trunks" className="alert-message alert-success is-hidden">
          <div className="alert-header">
            <span>Sucesso!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-update-trunks')}>×</button>
            </div>
          <div className="alert-body">
            Tronco atualizado com <strong>sucesso</strong>!
          </div>
        </div>
      </div>

      <div id="trunk-all-form" className="trunk-type-card">
        <p className="trunk-type-title">Tipo de Tronco</p>
        <div className="trunk-type-options">
          <div className="trunk-type-option">
            <input type="radio" id="type-auth-edit" name="type" value="Auth" checked={values.type === 'Auth'} onChange={(e) => typeTrunkSelected(e.target)} />
            <label htmlFor="type-auth-edit">Autenticado</label>
                    </div>
          <div className="trunk-type-option">
            <input type="radio" id="type-ip-edit" name="type" value="IP" checked={values.type === 'IP'} onChange={(e) => typeTrunkSelected(e.target)} />
            <label htmlFor="type-ip-edit">IP</label>
                  </div>
                </div>
        <p name="type-invalid-data" className="form-error is-hidden">Selecione o tipo de tronco!</p>
                    </div>

      {!canEditName && trunkUsageInfo && (
        <div className="alert-message alert-warning" style={{ marginBottom: '20px' }}>
          <div className="alert-header">
            <span>Aviso</span>
          </div>
          <div className="alert-body">
            <strong>O nome do tronco não pode ser alterado</strong><br />
            Este tronco possui {trunkUsageInfo.totalCount} configuração(ões) de chamadas ativa(s): {trunkUsageInfo.incomingCount} entrada e {trunkUsageInfo.outboundCount} saída.
            Para alterar o nome, é necessário remover todas as configurações de chamadas primeiro.
          </div>
        </div>
      )}

      <div name="trunk-ip-div" className="is-hidden">
        <div className="form-card">
          <TrunksIp changeValues={handleChangeValues} tenants={tenants} values={values} canEditName={canEditName} />
                </div>
              </div>

      <div name="trunk-auth-div" className="is-hidden">
        <div className="form-card">
          <TrunksAuth changeValues={handleChangeValues} tenants={tenants} values={values} canEditName={canEditName} />
        </div>
      </div>

      <div name="button-send-form" className="is-hidden">
        <div className="form-actions">
          <Link to="/config/tronco/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faArrowLeft} />
            Cancelar
          </Link>
          <button className="btn-submit" type="submit" disabled={disable} onClick={() => sendDataTrunkUpdate()}>
                  <FontAwesomeIcon icon={faSave} />
                <span>Salvar Alterações</span>
              </button>
        </div>
      </div>
    </div>
  );
}

export default TrunksEdit;
